export default {
  "b2b.zadosti-grid-columns.doplnkoveSluzby.label": "Additional services",
  "b2b.zadosti-grid-columns.posledniAktivita.label": "Last activity",
  "b2b.zadosti-grid-columns.projekt.label": "Project",
  "b2b.zadosti-grid-columns.termin.label": "Rezervation time",
  "b2b.zadosti-grid-columns.zadavatel.label": "Client",
  "b2b.zadosti-grid-columns.zdroj.label": "Resource",
  "b2b.zadosti-grid-columns.kolize.label": "Conflicts",
  "b2b.zadosti-grid-columns.fixni.label": "Fixed",
  "b2b.zadosti-grid-columns.datum-vytvoreni.label": "Created",
  "b2b.zadosti-grid-columns.stav.label": "Status"
};
